import {
  PaymentMethodCode,
  PaymentFamily,
  PAYMENT_METHOD_FAMILY
} from '../types';

/**
 * Mappe toute valeur (historique comme flouci ou code précis comme portefeuille_flouci)
 * vers une clé i18n générique (la famille).
 */
export function paymentMethodLocaleKey(mode: string): string {
  if (!mode) return '';
  
  // 1. Si c'est déjà une PaymentFamily
  if (Object.values(PaymentFamily).includes(mode as PaymentFamily)) {
    return mode;
  }
  
  // 2. Si c'est un code précis de la table admin (ex: portefeuille_flouci)
  if (Object.values(PaymentMethodCode).includes(mode as PaymentMethodCode)) {
    const family = PAYMENT_METHOD_FAMILY[mode as PaymentMethodCode];
    if (family) return family;
  }

  // 3. Fallback pour les historiques très spécifiques
  const legacyWalletModes = ['flouci', 'd17', 'izi_pay'];
  if (legacyWalletModes.includes(mode)) {
    return PaymentFamily.PORTEFEUILLE;
  }
  
  const legacyBankModes = ['carte_bancaire'];
  if (legacyBankModes.includes(mode)) {
    return PaymentFamily.CARTE;
  }
  
  const legacyPostalModes = ['postal'];
  if (legacyPostalModes.includes(mode)) {
    return PaymentFamily.MANDAT;
  }

  return mode;
}

/**
 * Filtre admin commandes/dépôts :
 * Permet de vérifier si une valeur en base (orderMode) correspond au filtre (filterValue).
 * Gère l'historique : si l'admin filtre sur "portefeuille", un "flouci" en base matchera.
 */
export function orderMatchesPaymentFilter(orderMode: string, filterValue: string): boolean {
  if (!filterValue) return true;
  if (!orderMode) return false;
  
  if (orderMode === filterValue) return true;

  const modeFamily = paymentMethodLocaleKey(orderMode);
  const filterFamily = paymentMethodLocaleKey(filterValue);
  
  return modeFamily === filterFamily;
}

/** Commandes / dépôts : rail portefeuille unique. */
export function isWalletRailPaymentMode(mode: string): boolean {
  return paymentMethodLocaleKey(mode) === PaymentFamily.PORTEFEUILLE;
}